"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title"],
  _excluded2 = ["aria-hidden"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M7.96 16h.029a.554.554 0 0 0 .197-.036c3.232-1.23 5.345-3.41 6.283-6.48.745-2.442.567-4.919.289-6.533l-1.092.285c.455 2.637.809 9.027-5.692 11.619-3.401-1.355-5.357-3.884-5.812-7.517-.3-2.398.179-4.546.327-5.125C3.647 1.352 6.563 1.123 8 1.123c1.484.011 4.264.319 5.405 1.093l.115.079 1.103-.502-.288-.255C12.665.057 8.396.005 8.03 0H8C6.793.036 3.138.146 1.632 1.48a.55.55 0 0 0-.164.257c-.032.106-3.082 10.659 6.294 14.227A.56.56 0 0 0 7.96 16Zm.606-9.11h3.244v1.012H8.566v3.244H7.554V7.902H4.31V6.89h3.244V3.646h1.012V6.89Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M11.683 23.963a.56.56 0 0 0 .2.037h.045a.554.554 0 0 0 .2-.037c4.876-1.855 8.064-5.14 9.476-9.767 1.19-3.894.786-7.835.44-9.838l-.018-.1-1.088.375c.714 4.134 1.263 14.18-9.032 18.212-5.398-2.113-8.5-6.092-9.219-11.825-.487-3.887.342-7.349.535-8.08 2.233-1.775 8.409-1.796 8.671-1.796h.055c2.407.02 6.646.496 8.466 1.73l.043.03 1.138-.518-.107-.095C19.175.24 13.062-.025 11.962 0h-.005C10.13.057 4.593.219 2.355 2.203a.56.56 0 0 0-.166.26c-.048.16-4.654 16.118 9.494 21.5Zm.898-12.614h4.93v1.302h-4.93v4.93H11.28v-4.93H6.35V11.35h4.93V6.42h1.302v4.93Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M15.578 31.95a.75.75 0 0 0 .267.05h.06a.74.74 0 0 0 .265-.05c6.502-2.472 10.753-6.854 12.636-13.022 1.585-5.193 1.048-10.447.585-13.117l-.023-.133-1.451.499c.952 5.513 1.684 18.906-12.043 24.283-7.197-2.818-11.333-8.122-12.291-15.766-.65-5.183.455-9.8.712-10.773 2.978-2.368 11.212-2.396 11.563-2.396h.073c3.209.026 8.861.661 11.287 2.307l.058.04 1.517-.69-.143-.128C25.566.321 17.415-.033 15.95.002h-.006c-2.436.072-9.82.29-12.804 2.934a.746.746 0 0 0-.22.347c-.064.213-6.205 21.49 12.659 28.667Zm1.197-16.818h6.573v1.736h-6.573v6.574h-1.736v-6.574H8.465v-1.736h6.574V8.559h1.736v6.573Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M23.588 47.938c.107.04.221.062.336.062h.09a.945.945 0 0 0 .335-.062c9.772-3.718 16.162-10.3 18.99-19.567 2.25-7.371 1.721-14.88.88-19.743l-1.86.488c1.453 8.41 2.554 28.787-18.39 36.946C12.977 41.782 6.662 33.703 5.2 22.048c-.997-7.954.717-14.992 1.1-16.418 4.458-3.614 16.765-3.7 17.645-3.7h.112c4.328.034 13.307.9 17.166 3.52l1.936-.88C38.361.316 25.517-.04 24.087.003 19.713.13 9.153.568 4.84 4.39a.945.945 0 0 0-.28.438c-.095.321-9.3 32.334 19.027 43.11Zm1.917-26.863H35.63v2.25H25.505V33.45h-2.25V23.325H13.13v-2.25h10.125V10.95h2.25v10.125Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M31.45 63.918c.142.054.294.082.447.082h.12c.153 0 .305-.028.447-.082 13.03-4.958 21.55-13.735 25.321-26.09 3-9.828 2.294-19.841 1.173-26.324l-2.48.65c1.937 11.215 3.405 38.384-24.52 49.262C17.3 55.709 8.881 44.938 6.933 29.398c-1.33-10.606.954-19.99 1.463-21.892 5.945-4.82 22.353-4.933 23.527-4.933h.081l.07-.001c5.77.046 17.742 1.2 22.888 4.694l2.581-1.174C51.146.42 34.021-.052 32.114.004c-5.83.17-19.91.754-25.66 5.85a1.26 1.26 0 0 0-.373.583c-.128.429-12.402 43.112 25.368 57.48Zm2.556-35.819h13.5v3h-13.5v13.5h-3V31.1h-13.5v-3h13.5V14.6h3v13.5Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconCoverages = function IconCoverages(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    title = _ref.title,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _props$ariaHidden = props["aria-hidden"],
    ariaHidden = _props$ariaHidden === void 0 ? 'true' : _props$ariaHidden,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded2);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  var finalAriaHidden = (title ? false : ariaHidden).toString();
  var finalTitle = finalAriaHidden === 'false' ? title || 'Coverages' : null;
  if (title && (ariaHidden === true || ariaHidden === 'true') && process.env.NODE_ENV !== 'production') {
    console.warn('Passing a custom title will set the aria-hidden attribute to false within IconCoverages. Consider passing aria-hidden="false" explicitly to IconCoverages for compatibility with future versions.');
  }
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: finalTitle,
    "aria-hidden": finalAriaHidden
  }, rest, {
    iconClass: "Coverages"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconCoverages.sizes = [16, 24, 32, 48, 64];
IconCoverages.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = exports.default = IconCoverages;